import { Argv } from 'yargs'

export const handler = (): null => null
export const command = 'env <command>'
export const description = `Manage CircleCI env's`
export const builder = (yargs: Argv): Argv => yargs.commandDir('env-commands')
